/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import LecturerListItem from './LecturerListItem'

class LecturerListcurrent extends React.Component {


    render() {
        const {selectedList} = this.props;
        return (
            <div className="lecturer-invite-list">
                {selectedList && selectedList.length > 0 &&
                selectedList.map((item,index) => <LecturerListItem type={'now'} key={index} content={item} />)
                }
            </div>
        )
    }
}

export default connect(state => ({
    selectedList: state.lecturerInvite.selectedList
}))(LecturerListcurrent)


// WEBPACK FOOTER //
// ./src/components/lecturerInvite/LecturerListcurrent.js